import React, { useState, useRef, useEffect } from 'react'
import clsx from 'clsx'
import { Link } from "react-router-dom";
import {
  AppBar, Badge, IconButton, Toolbar, Hidden, Typography,
  SwipeableDrawer, Menu, MenuItem, ListItemIcon, ListItemText, Avatar, Divider, Switch
} from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
import SettingsIcon from '@material-ui/icons/Settings'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import Brightness4Icon from '@material-ui/icons/Brightness4'
import { useAuth } from 'hooks/useAuth'
import { useThemeMode } from 'hooks/useThemeMode'
import useRouter from 'utils/useRouter'
import SearchBar from './components/SearchBar'
import { OperacaoVestigioLote } from 'components/OperacaoVestigioLote'
import { useCestaOperacaoLote } from 'hooks/useCestaOperacaoLote'
import { ReactComponent as Cesta } from './basket.svg'
import useStyles from './TopBar.styles'

export const TopBar = (props) => {
  const { onOpenNavBarMobile, className, ...rest } = props
  const classes = useStyles()
  const router = useRouter()
  const { isLogged, signOut, currentUser, socket } = useAuth()
  const { isDarkMode, toggleThemeMode } = useThemeMode()
  const { vestigiosSelecionados } = useCestaOperacaoLote()
  const [anchorDrawer, setAnchorDrawer] = useState(false)
  const [anchorElUser, setAnchorElUser] = useState(null)

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget)
  }

  const handleCloseUserMenu = () => {
    setAnchorElUser(null)
  }

  const handleLogout = () => {
    handleCloseUserMenu()
    signOut()
  }

  const handleClickOperacaoLote = () => {
    setAnchorDrawer(true)
  }



  return (
    <AppBar {...rest} className={clsx(classes.root, className)} color="primary">
      <Toolbar>
        {/* À ESQUERDA: Menu Mobile e Marca */}
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onOpenNavBarMobile} style={{ marginRight: '4px' }}>
            <MenuIcon />
          </IconButton>
        </Hidden>
        <Link to="/dashboard">
          <img
            alt="Logo SIGEP"
            src="/images/logo-sigep.png"
            className={classes.sigepLogo}
          />
        </Link>

        {/* CENTRO/ESQUERDA: Barra de Busca Modularizada */}
        <Hidden smDown>
          <div className={classes.searchContainer}>
            <SearchBar />
          </div>
        </Hidden>

        {/* ESPAÇADOR CENTRAL */}
        <div className={classes.flexGrow} />

        {/* À DIREITA: Botões de Ação Rápidos */}
        <div className={classes.iconActions}>


          {/* Cesta de Vestígios */}
          <Badge
            badgeContent={vestigiosSelecionados.length}
            color="secondary"
            overlap="rectangular"
            classes={{ badge: classes.cestaBadge }}
            style={{ marginLeft: '8px' }}
          >
            <IconButton color="inherit" onClick={handleClickOperacaoLote} style={{ padding: 8 }}>
              <Cesta className={classes.cestaIcon} alt="Cesta" />
            </IconButton>
          </Badge>
        </div>

        {/* SEÇÃO DO USUÁRIO: Nome Resumido + Avatar Circular */}
        {currentUser && (
          <div className={classes.userInfoWrapper} onClick={handleOpenUserMenu}>
            <Hidden xsDown>
              <Typography variant="body2" className={classes.infoUser}>
                {currentUser.nome ? currentUser.nome.split(' ')[0] : 'Usuário'}
              </Typography>
            </Hidden>
            <Avatar className={classes.userAvatar}>
              {currentUser.nome ? currentUser.nome.charAt(0).toUpperCase() : 'U'}
            </Avatar>
            <ExpandMoreIcon style={{ fontSize: '1rem', opacity: 0.7, marginLeft: 2 }} />
          </div>
        )}

        {/* MENU SUSPENSO DE AÇÕES DO USUÁRIO */}
        <Menu
          id="user-menu"
          anchorEl={anchorElUser}
          keepMounted
          open={Boolean(anchorElUser)}
          onClose={handleCloseUserMenu}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            style: { marginTop: 8, minWidth: 180 }
          }}
        >
          <div style={{ padding: '12px 16px' }}>
            <Typography variant="subtitle2" noWrap>{currentUser?.nome}</Typography>
            <Typography variant="caption" color="textSecondary" noWrap>
              {currentUser?.cargo?.nome || 'Sem cargo'}
            </Typography>
          </div>
          <Divider />
          <MenuItem disabled onClick={() => { handleCloseUserMenu(); router.history.push('/configuracoes'); }}>
            <ListItemIcon style={{ minWidth: 36 }}>
              <SettingsIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText dus primary="Configurações" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
          <MenuItem onClick={toggleThemeMode}>
            <ListItemIcon style={{ minWidth: 36 }}>
              <Brightness4Icon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Tema Escuro" primaryTypographyProps={{ variant: 'body2' }} />
            <Switch
              size="small"
              checked={isDarkMode}
              onChange={toggleThemeMode}
              color="secondary"
              onClick={(e) => e.stopPropagation()}
            />
          </MenuItem>
          <MenuItem onClick={handleLogout}>
            <ListItemIcon style={{ minWidth: 36 }}>
              <ExitToAppIcon fontSize="small" color="error" />
            </ListItemIcon>
            <ListItemText primary="Sair" primaryTypographyProps={{ variant: 'body2', color: 'error' }} />
          </MenuItem>
        </Menu>
      </Toolbar>


      <SwipeableDrawer
        anchor={'right'}
        open={anchorDrawer}
        onOpen={() => setAnchorDrawer(true)}
        onClose={() => setAnchorDrawer(false)}
      >
        <OperacaoVestigioLote setOpenMenuOperacao={setAnchorDrawer} />
      </SwipeableDrawer>
    </AppBar>
  )
}

export default TopBar
